<template>
    <v-row class="main-row-fill-height">
        <!-- <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;">
                    <v-toolbar absolute flat color="primary" width="100%" height="70px" dark>
                        <v-toolbar-title>Maßblatt</v-toolbar-title>
                    </v-toolbar>
                    <v-list class="pt-0">
                        <v-list-item-group v-model="active" color="grey darken-4">
                            <v-list-item 
                                :style="active === index ? 'pointer-events: none' : ''"
                                v-for="(item, index) in getMeasureItems"
                                :key="index"
                            >
                                <v-list-item-content>
                                    <div class="subtitle-1 d-flex align-center justify-space-between">
                                        {{ item.displayText }}
                                        <v-icon v-if="item.completed()" color="success" class="ml-4">mdi-check-circle</v-icon>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                     <div class="pa-4 mx-5 body-2 mt-4 text-container">
                       Alle mit diesem Programm erstellten Maße sind ausschließlich Vorschlagswerte. Technische Änderungen vorbehalten.
                    </div>
                    <div v-if="typeof bodenniveauunterschiedDocument !== 'undefined'" class="d-flex pa-3 mt-4 mx-5 document-container" >
                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                        <a class="black--text" target="_blank" :href="bodenniveauunterschiedDocument.resourceLocation" download>Bodenniveauunterschied Bild</a>
                    </div>
                </v-navigation-drawer>
            </v-card>
        </v-col> -->
        <v-col cols="9" class="pa-0 pos-rel pad-b">
            <div class="top-bar pl-14 pr-10 py-8" ref="topBar">
                <div class="content">
                    <div class="text-section">
                        <h2 class="mb-2 menu-title">{{$t('massblatt')}}</h2>
                        <p class="ma-0 menu-description">{{$t('masslattDescription')}}</p>
                    </div>
                    <a href="javascript:void(0)" @click="toggleResources = !toggleResources" class="resources-holder" v-if="showResources">
                        <div class="resources" :class="{ 'active': toggleResources }">
                            <div class="resources-placeholders">
                                <p class="menu-description">{{$t('resourcesLabel')}}</p>
                                <p class="font-weight-bold menu-title"><span>1</span> {{$t('documentLabel')}}</p>
                            </div>
                            <div class="pl-5 dropdown-icon">
                                <v-icon class="icon-class">mdi-menu-down</v-icon>
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div class="resources-dropdown" v-if="toggleResources">
                                <div class="resources-placeholders">
                                    <p class="menu-description">{{$t('resourcesLabel')}}</p>
                                    <p class="font-weight-bold menu-title"><span>1</span> {{$t('documentLabel')}}</p>
                                </div>
                                <div class="resources-content">
                                    <div v-if="(typeof bodenniveauunterschiedDocument !== 'undefined')" class="d-flex pa-3 mb-4 document-container" >
                                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                        <a class="black--text" target="_blank" :href="bodenniveauunterschiedDocument.resourceLocation" download>Bodenniveauunterschied Bild</a>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </a>
                </div>
            </div>
            <v-divider></v-divider>
            <v-card data-simplebar flat :style="{'height': `calc(100% - ${bodyCalcHeight}px)`, 'max-height' : '100%'}" class="pa-8 pl-12 pt-6">
                <simplebar style="overflow-x: hidden;" class="px-2">
                 <template v-if="getSubNavActiveId.mainNavActiveId == 3 && getSubNavActiveId.subNavActiveId == 0">
                     <h3 class="font-weight-regular mb-4 submenu-title">{{$t('auswahl')}}</h3>
                     <template v-if="dataLoaded">
                        <door-width :doorLeafSizesData="doorLeafSizesData"/>
                     </template>
                </template>
                <template v-if="getSubNavActiveId.mainNavActiveId == 3 && getSubNavActiveId.subNavActiveId == 1">
                     <h3 class="font-weight-regular mb-4 submenu-title">{{$t('oberblende')}}</h3>
                     <template v-if="dataLoaded">
                         <top-panel :doorLeafSizesData="doorLeafSizesData" />
                     </template>
                </template>
                <template v-if="getSubNavActiveId.mainNavActiveId == 3 && getSubNavActiveId.subNavActiveId == 2">
                    <h3 class="font-weight-regular mb-4 submenu-title">{{$t('staffelAuswahl')}}</h3>
                    <template v-if="dataLoaded"> 
                            <door-threshold /> 
                    </template>
                </template>
                <template v-if="getSubNavActiveId.mainNavActiveId == 3 && getSubNavActiveId.subNavActiveId == 3">
                    <h3 class="font-weight-regular mb-4 submenu-title">{{$t('gehUndStehflugel')}}</h3>
                    <template v-if="dataLoaded"> 
                        <door-wing-side :doorLeafSizesData="doorLeafSizesData"/>
                    </template>
                </template>
                <template v-if="getSubNavActiveId.mainNavActiveId == 3 && getSubNavActiveId.subNavActiveId == 4">
                    <h3 class="font-weight-regular mb-4 submenu-title">{{$t('turblattKurzung')}}</h3>
                    <template v-if="dataLoaded"> 
                        <door-leaf />
                    </template>
                </template>
                </simplebar>
            </v-card>
                <div class="bottom-bar pb-6 text-center">
                    <v-divider class="py-4"></v-divider>
                    <v-btn :disabled="nextSaveBtnDisabled" depressed color="green" dark @click="nextStep();">{{$t('nextStepLabel')}}</v-btn>
                </div>
        </v-col>
        <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;" permanent>
                    <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                        <ModelsFound />
                        <div class="pr-1">
                           <v-expansion-panels flat accordion>                 
                                <RModelSelection/>
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>                 
                                <RFunctions />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>                 
                                <RFrame />
                            </v-expansion-panels>
                             <v-expansion-panels flat accordion>                 
                                <RMeasures />
                            </v-expansion-panels>
                            
                        </div>
                        <div class="d-flex flex-column pa-4 right-buttons-holder">
                            <v-row class="px-2">
                                <v-col cols="6" class="px-2" v-if="newConfiguration">
                                    <v-btn outlined color="primary" width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">
                                        {{ $t('cancelConfiguration') }}
                                    </v-btn>
                                </v-col>
                                <v-col class="px-2" :class="!newConfiguration? 'col-12' : 'col-6'">
                                    <SaveCurrentConfiguration :disabled-save-btn="nextSaveBtnDisabled"/>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-navigation-drawer>
            </v-card>
        </v-col>
    </v-row>
    <!-- <div class="content-wrapper" id="measure">    
        <div class="wrapper-mask show" v-if="showModal"></div>
        <div class="row no-gutters content-row" v-if="!showModal">
            <div class="col-3">
                <div class="column-wrap d-flex flex-column">
                    <h3 class="title nav-title">Maßblatt</h3>
                    <div class="inner-wrap d-flex" data-simplebar>
                        <div class="nav flex-column nav-pills main-navigation text-left" id="v-pills-tab" role="tablist"
                            aria-orientation="vertical">

                            <a v-bind:class="{ 'nav-link': true, 'active': active == 1, 'success' : false }" @click.prevent="settingsNavigation(1)">Auswahl</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 2, 'success' : false }" @click.prevent="settingsNavigation(2)">Oberblende</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 3, 'success' : false }" @click.prevent="settingsNavigation(3)">Bodenanschlüsse</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 4, 'success' : false }" @click.prevent="settingsNavigation(4)">Geh-und Stehflugel</a>
                            <a v-bind:class="{ 'nav-link': true, 'active': active == 5, 'success' : false }" @click.prevent="settingsNavigation(5)">Turblatt Kurzung oder Verlangerung</a>
                        </div>
                        <div class="desc">Alle mit diesem Programm erstellten Maße sind ausschließlich Vorschlagswerte. Technische Änderungen vorbehalten.</div>

                        <div class="download-holder" v-if="typeof bodenniveauunterschiedDocument !== 'undefined'">
                            <a :href="bodenniveauunterschiedDocument.resourceLocation" class="download-btn" download target="_blank">Bodenniveauunterschied Bild</a>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-6 purple-background-after">
                <div class="column-wrap middle-col  d-flex flex-column">
                    <div class="inner-wrap d-flex" data-simplebar id="innerWrapper">
                        <div class="scroll-wrap">
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 1}">
                                <template v-if="dataLoaded">
                                    <door-width />
                                </template>
                            </div>
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 2}">
                                <template v-if="dataLoaded"> 
                                    <top-panel />
                                </template>
                            </div>
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 3}">
                                <template v-if="dataLoaded"> 
                                    <door-threshold />
                                </template>
                            </div>
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 4}">
                                <template v-if="dataLoaded"> 
                                    <door-wing-side />    
                                </template>                        
                            </div>
                            <div v-bind:class="{'inputs-group': true, 'active': showSettingsContent == 5}">
                                <template v-if="dataLoaded"> 
                                    <door-leaf />
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-3">
                <div class="column-wrap side-col d-flex flex-column justify-content-end">
                    <div class="side-wrap d-flex flex-column">
                        <div class="info-wrap">
                            <ModelsFound />
                            <div class="inner-wrap d-flex right-part-inner-wrap" data-simplebar>
                                <RModelSelection></RModelSelection>
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-header" id="headingOne">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" type="button" data-toggle="collapse"
                                                    data-target="#collapseOne3" aria-expanded="true" aria-controls="collapseOne">
                                                    Funktionsauswahl
                                                </button>
                                            </h5>
                                        </div>

                                        <div id="collapseOne3" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                            <RFunctions></RFunctions>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingTwo">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" type="button" data-toggle="collapse"
                                                    data-target="#collapseTwo3" aria-expanded="false" aria-controls="collapseTwo">
                                                    Zargenauswahl
                                                </button>
                                            </h5>
                                        </div>
                                        <div id="collapseTwo3" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                            <RFrame></RFrame>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="headingThree">
                                            <h5 class="mb-0">
                                                <button class="btn btn-link collapsed" type="button" data-toggle="collapse"
                                                    data-target="#collapseThree3" aria-expanded="false" aria-controls="collapseThree">
                                                    Maßlatt
                                                </button>
                                            </h5>
                                        </div>
                                        <div id="collapseThree3" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                                            <RMeasures></RMeasures>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <v-app>
                                <div class="d-flex flex-column pa-4">
                                    <v-btn depressed color="green" dark @click="nextStep();">Weiter</v-btn>
                                    
                                    <v-row class="px-2">
                                        <v-col cols="6" class="px-2">
                                            <v-btn width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">Cancel</v-btn> 
                                        </v-col>
                                        <v-col cols="6" class="px-2">
                                            <SaveCurrentConfiguration />   
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-app>
                        </div>
                    </div>                    
                </div>
            </div>
            
        </div>
        <div class="row no-gutters modal-row show" v-if="showModal">
            <div class="col-12">
                <div class="zoom-modal d-flex">
                    <a @click.prevent="toggleModal(false)" class="close-btn">
                        <img src="./../../assets/images/close.svg" alt="">
                    </a>
                    <img src="./../../assets/images/sample.svg" alt="" class="align-middle">
                </div>
            </div>
        </div>
    </div> -->
</template>
<script>
import * as $ from 'jquery';
import Vue from 'vue';
import { Characteristic, ValueDefinition, MapCharacteristicAndValue, DependenciesFilter } from '../../configurator/types';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import ModelsFound from './components/ModelsFound';
import { DoorConfiguration } from '../../configurator/DoorConfiguration';
import { MainNavigationFilter } from '../../configurator/MainNavigation';
import SaveCurrentConfiguration from './components/SaveCurrentConfiguration';
import nProgress from 'nprogress';
import resourcesService from '../../services/Configurator/ResourcesService';
import measureService from '../../services/Configurator/MeasureService';

import RModelSelection from './components/RModelSelection.vue';
import RFunctions from './components/RFunctions.vue';
import RFrame from './components/RFrame.vue';
import RMeasures from './components/RMeasures.vue';

import DoorWidth from './measure/DoorWidth';
import TopPanel from './measure/TopPanel.vue';
import DoorThreshold from './measure/DoorThreshold.vue';
import DoorLeaf from './measure/DoorLeaf.vue';
import DoorWingSide from './measure/DoorWingSide.vue';
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';

export default Vue.extend({
    name: 'Measure',
        components: {
            simplebar,
            RModelSelection,  
            RFunctions,
            RFrame,
            RMeasures,
            ModelsFound,
            'door-width': DoorWidth,
            'top-panel': TopPanel,
            'door-threshold': DoorThreshold,
            'door-leaf': DoorLeaf,
            'door-wing-side': DoorWingSide,
            SaveCurrentConfiguration
        },
        data() {
            return {
                showResources: true,
                toggleResources: false,
                showModal: false,
                showSettingsContent: 1,
                active: 0,
                settignsItems: [],
                windowMainNavId: 4,   
                context: DoorConfiguration.Measure,
                dataLoaded : false, 
                bodenniveauunterschiedDocument: {},
                doorLeafSizesData: {},
                bodyCalcHeight: 0,
                nextSaveBtnDisabled: false
            }
        },
        computed: {
            ...mapGetters('configuratorModule',['getSubNavActiveId', 'getCurrentDoorConfiguration', 'getMainNav', 'getRegisteredCharacteristicsValue','getMeasureItems']),
            ...mapGetters('measureModule', ['getMeasureCharacteristics', 'getDoorLeafSizes']),
            newConfiguration: function(){
                if(this.$store.state.configuratorModule.productId == 0){
                    return true
                }
                else{
                    return false
                }
            }
        },
        methods : {
            ...mapActions('configuratorModule',['updateDoorConfiguration', 'setMainNavigationItems', 'setMainNavActiveId','setSingleCharacteristicsFilteredOrDefaults', 'incrementMainNavActiveId']),
            toggleModal(state) {
                this.showModal = state;
            },
            settingsNavigation(index) {
                this.active = index;
                this.showSettingsContent = index;
            },
            addCharacterisitc(characteristic, valueDefinition) { 
                const val = {
                    id: valueDefinition.id,
                    description: valueDefinition.description,
                    value: valueDefinition.value,
                    resource: valueDefinition.resource,
                };

                const selectedCharacteristic = {
                    id: characteristic.id,
                    description: characteristic.description,
                    code: characteristic.code,
                    value: val             
                };
                       
                this.doorConfiguration = this.getCurrentDoorConfiguration;
                       
                this.doorConfiguration.Add(DoorConfiguration.Measure, selectedCharacteristic);
                       
                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration); 
                // this.updateNavigation();
            },
            async getCharacteristics() {  
                       
                NProgress.start();
                this.nextSaveBtnDisabled = true
                measureService.getMeasuresCharacteristics().then(async response => {
                    this.$store.dispatch('measureModule/setMeasureCharacteristics', response.data);
                    this.$store.dispatch('measureModule/setSingleCharacteristicsFilteredOrDefaults');
                    await this.filterMeasureDependencies();
                    this.dataLoaded = true;
                }).finally(() => {
                    NProgress.done();
                    this.nextSaveBtnDisabled = false
                });
            },
            resetModelSelection(){      
                       
                this.doorConfiguration = this.getCurrentDoorConfiguration;    
                            
                this.doorConfiguration.ClearConfiguration(DoorConfiguration.Measure);   
                                    
                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);

                this.resetAdditionalValuesToDefault();
                
                this.updateNavigation(); 
                let mainNav = new MainNavigationFilter(this.getMainNav);
                let mainNavItems = mainNav.ResetMainNavigationItemStatus(this.windowMainNavId, false);
                this.setMainNavigationItems(mainNavItems);               
            },
            resetAdditionalValuesToDefault(){
                //START This block is for reseting meassure related objects to zero
                const resetedMeassure = {
                    width: 0,
                    heightBS: 0,
                    heightGBS: 0,
                }
                this.$store.dispatch('measureModule/setDoorMeasure', resetedMeassure);
                
                 const resetedTrafficDoor =  {
                    WidthSym: 0,
                    WidthAsym: 0,
                    Width: 0,
                }
                this.$store.dispatch('measureModule/setTrafficDoor', resetedTrafficDoor);

                const resetedThreshold =  {
                    HeightValueVS : 0,
                    HeightValueBS : 0,
                    HeightValue: 0,
                }
                this.$store.dispatch('measureModule/setThreshold', resetedThreshold);
                //END
            },
            nextStep() {
                
                let mainNav = new MainNavigationFilter(this.getMainNav);
                       
                let mainNavItems = mainNav.UpdateMainNavigation(this.getMeasureItems, this.windowMainNavId + 1);
                // this.$store.dispatch('setMainNavigationItems', mainNavItems);
                this.setMainNavigationItems(mainNavItems);

                const nextMainNavItem = mainNavItems.filter(x => x.itemId == this.windowMainNavId + 1)[0];
                if(nextMainNavItem.disabled == false) {
                    /* this.setMainNavActiveId(this.windowMainNavId + 1); */
					const activeMainNavIndex = this.getMainNav.findIndex(f => f.itemId === this.windowMainNavId)
					this.incrementMainNavActiveId(activeMainNavIndex);
					this.$EventBus.$emit('triggerMaxHeight')
                    this.$router.push('/product-configurator' + nextMainNavItem.route);
                }
                else {
                    console.log('Measure step not completed!');
                }            
            },
             async filterMeasureDependencies() {
                await this.filterDependencies('KTU_MM_O_STUMPF');
                await this.filterDependencies('CUST_MM_ABSENKDICHTUNG');
                await this.filterDependencies('CUST_MM_TUER_MASS_SYM');
                
                var hasTopPanel = this.$store.getters['configuratorModule/getCurrentDoorConfiguration'].GetHasTopPannel();
                if(hasTopPanel === true)
                {
                    await this.filterDependencies('KTU_MM_OBERBLENDE');
                }
            },
            async filterDependencies(characteristicCode){
                await this.$store.dispatch('measureModule/setCharacteristicDependencies', characteristicCode);
            },
            bodenniveauunterschiedDocumentResource: function() {
                const _this = this;
                var resource = resourcesService.getResourcesByCharacteristicCode('KTU_MM_NIVEAU_ART');

                resource.then(function(result) { 
                    _this.bodenniveauunterschiedDocument = result.data[0];                    
                })
            },
            getDoorLeafSizesMethod() {
                let itemNumber = this.getRegisteredCharacteristicsValue('KTU_MM_ARTIKELNR', DoorConfiguration.ModelSelection).value.value;

                let doorLeafSizes = this.getDoorLeafSizes.find(x => x.itemNumber === itemNumber);
                this.doorLeafSizesData = doorLeafSizes;
            },
            recalcBodyHeight(){
                //calculation of top-bar height 
                if(this.$refs.topBar.clientHeight != this.bodyCalcHeight)
                    this.bodyCalcHeight = this.$refs.topBar.clientHeight;
            }
        },
        created() {
            window.addEventListener("resize", this.recalcBodyHeight);
        },
        destroyed() {
            window.removeEventListener("resize", this.recalcBodyHeight);
        },
        mounted() {
            console.log("mounted meassure");       
            this.getCharacteristics();
            this.$store.dispatch('measureModule/setMaterials');
            this.bodenniveauunterschiedDocumentResource();
            this.getDoorLeafSizesMethod();

            //calculation of top-bar height 
            this.bodyCalcHeight = this.$refs.topBar.clientHeight;
        },
        updated() {
           
        }
});
</script>
<style lang="scss" scoped>
.main-row-fill-height{
    height: 100%;
    margin-left: 0;
    margin-right: 0;
    >.col{
        max-height: 100%;
    }
}
.text-container,.document-container{
    background: #efefef;
}
</style>